import { render, staticRenderFns } from "./UserPublications.vue?vue&type=template&id=057defb4&scoped=true&"
import script from "./UserPublications.vue?vue&type=script&lang=js&"
export * from "./UserPublications.vue?vue&type=script&lang=js&"
import style0 from "./UserPublications.vue?vue&type=style&index=0&id=057defb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057defb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCard,VIcon})
